import Weight from '../../../../../common/components/Weight.js'
import {
  shippedTotalWeightSelector,
  isShippedMultiboxSelector,
} from '../../../../../data/orders.js'

import LabelItem from './LabelItem.js'
import {useSelector} from '../../../../../store.js'

export default function ShippedWeight({orderNumber}) {
  const weight = useSelector((state) =>
    shippedTotalWeightSelector(state, {orderNumber}),
  )
  const isMultibox = useSelector((state) =>
    isShippedMultiboxSelector(state, {orderNumber}),
  )

  if (isMultibox) {
    return null
  }

  return (
    <LabelItem label="Weight">
      <Weight value={weight} />
    </LabelItem>
  )
}
